@if (!isLoading) {
    <div class="main-navbar-container max-width-container">
        <navbar class="main-navbar side-padding flex lg:flex-row flex-col font-medium xl:text-lg lg:text-base text-sm pt-3">
            <ng-container *ngFor="let item of menu; let i = index">
                @if (userDetails?.isAAEEnabled || item.menuType !== MenuType.AskAnExpert) {
                    <a
                        *ngIf="!item.children"
                        class="menu-link menu-item relative"
                        [id]="item.htmlId"
                        [ngClass]="item.cssClass"
                        [routerLink]="item.link"
                        (click)="onLinkClick(item.param)">
                        {{ item.label | translate }}
                        <span
                            *ngIf="item.icon"
                            class="icon-[1.5rem] absolute top-[-0.75rem] lg:-top-2.5"
                            [ngClass]="item.icon"></span>
                    </a>

                    <div *ngIf="item.children" class="sub-menu-container lg:relative">
                        <button
                            type="button"
                            [ngClass]="{ 'menu-item flex': isMobile }"
                            (click)="isMobile && toggleMenu(item.menuType, true)">
                            <a
                                class="flex items-center lg:justify-start justify-between"
                                [ngClass]="isMobile ? 'max-w-fit' : 'menu-item'"
                                [id]="item.htmlId"
                                [routerLink]="item.link"
                                (click)="
                                    item.link ? $event.stopPropagation() : null;
                                    item.link ? onLinkClick(item.param) : null
                                "
                                (mouseenter)="!isMobile && toggleMenu(item.menuType, true)">
                                {{ item.label | translate }}
                                <span
                                    *ngIf="!isMobile"
                                    class="inline-block icon-[0.625rem] ml-2 bg-arrow-up-icon transition-all duration-200"
                                    [ngClass]="
                                        selectedMainMenuType !== null && selectedMainMenuType === item.menuType
                                            ? 'rotate-0'
                                            : 'rotate-180'
                                    "></span>
                            </a>

                            <span
                                *ngIf="isMobile"
                                class="inline-block icon-[0.625rem] ml-auto bg-arrow-up-icon transition-all duration-200"
                                [ngClass]="
                                    selectedMainMenuType !== null && selectedMainMenuType === item.menuType
                                        ? 'rotate-0'
                                        : 'rotate-180'
                                "></span>
                        </button>
                        <div
                            *ngIf="item.menuType === selectedMainMenuType"
                            #dropdownMenu
                            class="lg:absolute top-11 custom-menu">
                            <ng-container *ngTemplateOutlet="recursion; context: { list: item }"></ng-container>
                        </div>
                    </div>
                }
            </ng-container>
        </navbar>
    </div>

    <ng-template #recursion let-list="list">
        <div class="lg:flex transition-all" (mouseleave)="toggleMenu(list.menuType, false)">
            <div class="w-full lg:min-w-64 xl:min-w-72 p-4 space-y-4">
                <ng-container *ngFor="let item of list.children">
                    <button
                        type="button"
                        class="flex items-center w-full hover:text-[#004B65] text-start"
                        (click)="isMobile && !item.children && onLinkClick(item.param)"
                        (mouseenter)="onSubMenuSelected(item.id, SubMenuLevel.FirstLevel)">
                        <a
                            [ngClass]="{ '!text-[#004B65]': subMenuFirstLevelSelectedId === item.id }"
                            [routerLink]="item.link"
                            (click)="onLinkClick(item.param)"
                            >{{ item.label | translate }}</a
                        >
                        @if (item.children) {
                            <button
                                type="button"
                                class="items-center ml-4"
                                [ngClass]="subMenuFirstLevelSelectedId === item.id ? 'flex' : 'hidden'">
                                <mat-icon class="w-[14px] text-[#004B65]" svgIcon="arrow-right-short"></mat-icon>
                            </button>
                        }
                    </button>
                </ng-container>
            </div>

            @if (subMenuData) {
                <div
                    *ngIf="list.menuType === selectedMainMenuType && subMenuData.length > 0"
                    class="w-full p-4 bg-[#e5f8ff] rounded-lg lg:flex"
                    [class.rounded-r-lg]="">
                    <div class="space-y-4 lg:pb-0 pb-4">
                        <ng-container *ngFor="let item of subMenuData">
                            <button
                                type="button"
                                class="flex lg:min-w-72 xl:min-w-80 pr-7 items-center w-full hover:underline text-start"
                                (click)="isMobile && !item.children && onLinkClick(item.param)"
                                (mouseenter)="onSubMenuSelected(item.id, SubMenuLevel.SecondLevel)">
                                <a
                                    [ngClass]="{ '!text-[#004B65]': subMenuSecondLevelSelectedId === item.id }"
                                    [routerLink]="item.link"
                                    (click)="onLinkClick(item.param)"
                                    >{{ item.label | translate }}</a
                                >
                                @if (item.children) {
                                    <button
                                        type="button"
                                        class="items-center ml-4"
                                        [ngClass]="subMenuSecondLevelSelectedId === item.id ? 'flex' : 'hidden'">
                                        <mat-icon
                                            class="w-[14px] text-[#004B65]"
                                            svgIcon="arrow-right-short"></mat-icon>
                                    </button>
                                }
                            </button>
                        </ng-container>
                    </div>

                    @if (list.menuType === selectedMainMenuType && subMenuSecondLevelSelectedId) {
                        @for (item of subMenuData; track item) {
                            @if (item.id === subMenuSecondLevelSelectedId && item.children?.length) {
                                <div
                                    class="border-l-0 lg:border-l-[2px] lg:pl-7 lg:min-w-72 xl:min-w-80 border-t-[2px] lg:border-t-0 pt-4 lg:pt-0 border-l-[#B8D1DA] border-t-[#B8D1DA] w-full bg-[#e5f8ff] rounded-r-lg space-y-4">
                                    @for (child of item.children; track child) {
                                        <div class="flex items-center w-full hover:underline">
                                            <a [routerLink]="child.link" (click)="onLinkClick(item.param)">
                                                {{ child.label | translate }}
                                            </a>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    }
                </div>
            }
        </div>
    </ng-template>
}
